import { useContext, useMemo } from 'react'
import { SectionHeading } from '../../../../../Components/Headers'
import { Box } from '../../../../../Components/Layout'
import { PlayerProfileContext } from '../../../../../Context/PlayerProfileContext/PlayerProfileContext'
import { ValuesInRowContainer } from '../../Value'
import { CareerProgression } from './CareerProgression'

export const CareerStats: React.FC = () => {
  const { career, getStats } = useContext(PlayerProfileContext)!

  const careerStats = useMemo(() => {
    if (!career) return []
    return getStats('career', false, career)
  }, [career])

  if (!careerStats) return null
  return (
    <Box>
      <CareerProgression />
      
      <SectionHeading>
        <strong>Career Stats</strong>
      </SectionHeading>
      <ValuesInRowContainer noBorder values={careerStats} switchOn="md" />
    </Box>
  )
}
